export const countriesWithNationalities = {
    Afghanistan: "Afghan",
    Albania: "Albanian",
    Algeria: "Algerian",
    Andorra: "Andorran",
    Angola: "Angolan",
    Anguilla: "Anguillan",
    Argentina: "Argentine",
    Armenia: "Armenian",
    Australia: "Australian",
    Austria: "Austrian",
    Azerbaijan: "Azerbaijani",
    Bahamas: "Bahamian",
    Bahrain: "Bahraini",
    Bangladesh: "Bangladeshi",
    Barbados: "Barbadian",
    Belarus: "Belarusian",
    Belgium: "Belgian",
    Belize: "Belizean",
    Benin: "Beninese",
    Bermuda: "Bermudian",
    Bhutan: "Bhutanese",
    "Bolivia (Plurinational State of)": "Bolivian",
    Botswana: "Botswanan",
    Brazil: "Brazilian",
    "Brunei Darussalam": "Bruneian",
    Bulgaria: "Bulgarian",
    Burundi: "Burundian",
    Cambodia: "Cambodian",
    Cameroon: "Cameroonian",
    Canada: "Canadian",
    "Central African Republic": "Central African",
    Chad: "Chadian",
    Chile: "Chilean",
    China: "Chinese",
    Colombia: "Colombian",
    Comoros: "Comoran",
    "Costa Rica": "Costa Rican",
    "Côte d'Ivoire": "Ivorian",
    Croatia: "Croatian",
    Cuba: "Cuban",
    Cyprus: "Cypriot",
    "Czech Republic": "Czech",
    Denmark: "Danish",
    Djibouti: "Djiboutian",
    Dominica: "Dominican",
    "Dominican Republic": "Dominican",
    "Democratic Republic of the Congo": "Congolese (DRC)",
    DRC: "Congolese (DRC)",
    DPRK: "North Korean",
    Egypt: "Egyptian",
    "Equatorial Guinea": "Equatorial Guinean",
    Eritrea: "Eritrean",
    Estonia: "Estonian",
    Ethiopia: "Ethiopian",
    "Faroe Islands": "Faroese",
    Fiji: "Fijian",
    Finland: "Finnish",
    France: "French",
    Gabon: "Gabonese",
    Gambia: "Gambian",
    Georgia: "Georgian",
    Germany: "German",
    Ghana: "Ghanaian",
    Greece: "Greek",
    Greenland: "Greenlandic",
    Grenada: "Grenadian",
    Guam: "Guamanian",
    Guatemala: "Guatemalan",
    Guinea: "Guinean",
    Guyana: "Guyanese",
    Haiti: "Haitian",
    Honduras: "Honduran",
    Hungary: "Hungarian",
    Iceland: "Icelandic",
    India: "Indian",
    Indonesia: "Indonesian",
    Iran: "Iranian",
    Iraq: "Iraqi",
    Ireland: "Irish",
    Israel: "Israeli",
    Italy: "Italian",
    Jamaica: "Jamaican",
    Japan: "Japanese",
    Jordan: "Jordanian",
    Kazakhstan: "Kazakh",
    Kenya: "Kenyan",
    "Korea (Democratic People's Republic of)": "North Korean",
    "Korea (Republic of)": "South Korean",
    Kuwait: "Kuwaiti",
    Kyrgyzstan: "Kyrgyz",
    "Lao People's Democratic Republic": "Lao",
    Latvia: "Latvian",
    Lebanon: "Lebanese",
    Liberia: "Liberian",
    Libya: "Libyan",
    Lithuania: "Lithuanian",
    Macao: "Chinese",
    "Macedonia (the former Yugoslav Republic of)": "Macedonian",
    Madagascar: "Malagasy",
    Malawi: "Malawian",
    Malaysia: "Malaysian",
    Maldives: "Maldivian",
    Mali: "Malian",
    Malta: "Maltese",
    "Marshall Islands": "Marshallese",
    Martinique: "Martiniquais",
    Mauritania: "Mauritanian",
    Mauritius: "Mauritian",
    Mexico: "Mexican",
    "Micronesia (Federated States of)": "Micronesian",
    "Moldova (Republic of)": "Moldovan",
    Mongolia: "Mongolian",
    Montenegro: "Montenegrin",
    Montserrat: "Montserratian",
    Morocco: "Moroccan",
    Mozambique: "Mozambican",
    Myanmar: "Burmese",
    Namibia: "Namibian",
    Nauru: "Nauruan",
    Nepal: "Nepalese",
    Netherlands: "Dutch",
    Nicaragua: "Nicaraguan",
    Niger: "Nigerien",
    Nigeria: "Nigerian",
    Niue: "Niuean",
    Norway: "Norwegian",
    Oman: "Omani",
    Pakistan: "Pakistani",
    Palau: "Palauan",
    "Palestine, State of": "Palestinian",
    Panama: "Panamanian",
    "Papua New Guinea": "Papua New Guinean",
    Paraguay: "Paraguayan",
    Peru: "Peruvian",
    Philippines: "Filipino",
    Poland: "Polish",
    Portugal: "Portuguese",
    "Puerto Rico": "Puerto Rican",
    Qatar: "Qatari",
    Romania: "Romanian",
    "Russian Federation": "Russian",
    Rwanda: "Rwandan",
    "Saint Vincent and the Grenadines": "Vincentian",
    Samoa: "Samoan",
    "San Marino": "Sammarinese",
    "Saudi Arabia": "Saudi Arabian",
    Senegal: "Senegalese",
    Serbia: "Serbian",
    "Sierra Leone": "Sierra Leonean",
    Singapore: "Singaporean",
    Slovakia: "Slovak",
    Slovenia: "Slovenian",
    Somalia: "Somali",
    "South Africa": "South African",
    "South Sudan": "South Sudanese",
    Spain: "Spanish",
    "Sri Lanka": "Sri Lankan",
    Sudan: "Sudanese",
    Suriname: "Surinamese",
    Swaziland: "Swazi",
    Sweden: "Swedish",
    Switzerland: "Swiss",
    "Syrian Arab Republic": "Syrian",
    "Taiwan, Province of China": "Taiwanese",
    "Tanzania, United Republic of": "Tanzanian",
    Thailand: "Thai",
    Togo: "Togolese",
    Tonga: "Tongan",
    Tunisia: "Tunisian",
    Turkey: "Turkish",
    Turkmenistan: "Turkmen",
    Tuvalu: "Tuvaluan",
    Uganda: "Ugandan",
    Ukraine: "Ukrainian",
    "United Arab Emirates": "Emirati",
    UAE: "Emirati",
    KSA: "Saudi Arabian",
    "United Kingdom of Great Britain and Northern Ireland": "British",
    "United Kingdom": "British",
    UK: "British",
    GB: "British",
    "Great Britain": "British",
    "United States Minor Outlying Islands": "American",
    "United States of America": "American",
    USA: "American",
    US: "American",
    Uruguay: "Uruguayan",
    Uzbekistan: "Uzbek",
    "Venezuela (Bolivarian Republic of)": "Venezuelan",
    Vietnam: "Vietnamese",
    Yemen: "Yemeni",
    Zambia: "Zambian",
    Zimbabwe: "Zimbabwean",
};
export const nationalitiesWithISO = {
    Afghan: "AF",
    Albanian: "AL",
    Algerian: "DZ",
    American: "US",
    Andorran: "AD",
    Angolan: "AO",
    Anguillan: "AI",
    "Citizen of Antigua and Barbuda": "AG",
    Argentine: "AR",
    Armenian: "AM",
    Australian: "AU",
    Austrian: "AT",
    Azerbaijani: "AZ",
    Bahamian: "BS",
    Bahraini: "BH",
    Bangladeshi: "BD",
    Barbadian: "BB",
    Belarusian: "BY",
    Belgian: "BE",
    Belizean: "BZ",
    Beninese: "BJ",
    Bermudian: "BM",
    Bhutanese: "BT",
    Bolivian: "BO",
    "Citizen of Bosnia and Herzegovina": "BA",
    Botswanan: "BW",
    Brazilian: "BR",
    British: "GB-BRITISH",
    "British Virgin Islander": "VG",
    Bruneian: "BN",
    Bulgarian: "BG",
    Burkinan: "BF",
    Burmese: "MM",
    Burundian: "BI",
    Cambodian: "KH",
    Cameroonian: "CM",
    Canadian: "CA",
    "Cape Verdean": "CV",
    "Cayman Islander": "KY",
    "Central African": "CF",
    Chadian: "TD",
    Chilean: "CL",
    Chinese: "CN",
    Colombian: "CO",
    Comoran: "KM",
    "Congolese (Congo)": "CG",
    "Congolese (DRC)": "CD",
    "Cook Islander": "CK",
    "Costa Rican": "CR",
    Croatian: "HR",
    Cuban: "CU",
    Cymraes: "GB-CYMRAES",
    Cymro: "GB-CYMRO",
    Cypriot: "CY",
    Czech: "CZ",
    Danish: "DK",
    Djiboutian: "DJ",
    Dominican: "DM",
    "Citizen of the Dominican Republic": "DO",
    Dutch: "NL",
    "East Timorese": "TL",
    Ecuadorean: "EC",
    Egyptian: "EG",
    Emirati: "AE",
    English: "GB-ENGLISH",
    "Equatorial Guinean": "GQ",
    Eritrean: "ER",
    Estonian: "EE",
    Ethiopian: "ET",
    Faroese: "FO",
    Fijian: "FJ",
    Filipino: "PH",
    Finnish: "FI",
    French: "FR",
    Gabonese: "GA",
    Gambian: "GM",
    Georgian: "GE",
    German: "DE",
    Ghanaian: "GH",
    Gibraltarian: "GI",
    Greek: "GR",
    Greenlandic: "GL",
    Grenadian: "GD",
    Guamanian: "GU",
    Guatemalan: "GT",
    "Citizen of Guinea-Bissau": "GW",
    Guinean: "GN",
    Guyanese: "GY",
    Haitian: "HT",
    Honduran: "HN",
    "Hong Konger": "HK",
    Hungarian: "HU",
    Icelandic: "IS",
    Indian: "IN",
    Indonesian: "ID",
    Iranian: "IR",
    Iraqi: "IQ",
    Irish: "IE",
    Israeli: "IL",
    Italian: "IT",
    Ivorian: "CI",
    Jamaican: "JM",
    Japanese: "JP",
    Jordanian: "JO",
    Kazakh: "KZ",
    Kenyan: "KE",
    Kittitian: "KN",
    "Citizen of Kiribati": "KI",
    Kosovan: "XK",
    Kuwaiti: "KW",
    Kyrgyz: "KG",
    Lao: "LA",
    Latvian: "LV",
    Lebanese: "LB",
    Liberian: "LR",
    Libyan: "LY",
    "Liechtenstein citizen": "LI",
    Lithuanian: "LT",
    Luxembourger: "LU",
    Macanese: "MO",
    Macedonian: "MK",
    Malagasy: "MG",
    Malawian: "MW",
    Malaysian: "MY",
    Maldivian: "MV",
    Malian: "ML",
    Maltese: "MT",
    Marshallese: "MH",
    Martiniquais: "MQ",
    Mauritanian: "MR",
    Mauritian: "MU",
    Mexican: "MX",
    Micronesian: "FM",
    Moldovan: "MD",
    Monegasque: "MC",
    Mongolian: "MN",
    Montenegrin: "ME",
    Montserratian: "MS",
    Moroccan: "MA",
    Mosotho: "LS",
    Mozambican: "MZ",
    Namibian: "NA",
    Nauruan: "NR",
    Nepalese: "NP",
    "New Zealander": "NZ",
    Nicaraguan: "NI",
    Nigerian: "NG",
    Nigerien: "NE",
    Niuean: "NU",
    "North Korean": "KP",
    "Northern Irish": "GB-NORTHERNIRISH",
    Norwegian: "NO",
    Omani: "OM",
    Pakistani: "PK",
    Palauan: "PW",
    Palestinian: "PS",
    Panamanian: "PA",
    "Papua New Guinean": "PG",
    Paraguayan: "PY",
    Peruvian: "PE",
    "Pitcairn Islander": "PN",
    Polish: "PL",
    Portuguese: "PT",
    Prydeinig: "GB-PRYDEINIG",
    "Puerto Rican": "PR",
    Qatari: "QA",
    Romanian: "RO",
    Russian: "RU",
    Rwandan: "RW",
    Salvadorean: "SV",
    Sammarinese: "SM",
    Samoan: "WS",
    "Sao Tomean": "ST",
    "Saudi Arabian": "SA",
    Scottish: "GB-SCOTTISH",
    Senegalese: "SN",
    Serbian: "RS",
    "Citizen of Seychelles": "SC",
    "Sierra Leonean": "SL",
    Singaporean: "SG",
    Slovak: "SK",
    Slovenian: "SI",
    "Solomon Islander": "SB",
    Somali: "SO",
    "South African": "ZA",
    "South Korean": "KR",
    "South Sudanese": "SS",
    Spanish: "ES",
    "Sri Lankan": "LK",
    "St Helenian": "SH-STHELENIAN",
    "St Lucian": "LC",
    Stateless: "UN",
    Sudanese: "SD",
    Surinamese: "SR",
    Swazi: "SZ",
    Swedish: "SE",
    Swiss: "CH",
    Syrian: "SY",
    Taiwanese: "TW",
    Tajik: "TJ",
    Tanzanian: "TZ",
    Thai: "TH",
    Togolese: "TG",
    Tongan: "TO",
    Trinidadian: "TT",
    Tristanian: "SH-TRISTANIAN",
    Tunisian: "TN",
    Turkish: "TR",
    Turkmen: "TM",
    "Turks and Caicos Islander": "TC",
    Tuvaluan: "TV",
    Ugandan: "UG",
    Ukrainian: "UA",
    Uruguayan: "UY",
    Uzbek: "UZ",
    "Vatican citizen": "VA",
    "Citizen of Vanuatu": "VU",
    Venezuelan: "VE",
    Vietnamese: "VN",
    Vincentian: "VC",
    Wallisian: "WF",
    Welsh: "GB-WELSH",
    Yemeni: "YE",
    Zambian: "ZM",
    Zimbabwean: "ZW",
};
export default [
    "Afghan",
    "Albanian",
    "Algerian",
    "American",
    "Andorran",
    "Angolan",
    "Anguillan",
    "Antiguan",
    "Citizen of Antigua and Barbuda",
    "Argentine",
    "Armenian",
    "Australian",
    "Austrian",
    "Azerbaijani",
    "Bahamian",
    "Bahraini",
    "Bangladeshi",
    "Barbadian",
    "Belarusian",
    "Belgian",
    "Belizean",
    "Beninese",
    "Bermudian",
    "Bhutanese",
    "Bolivian",
    "Citizen of Bosnia and Herzegovina",
    "Botswanan",
    "Brazilian",
    "British",
    "British Virgin Islander",
    "Bruneian",
    "Bulgarian",
    "Burkinan",
    "Burmese",
    "Burundian",
    "Cambodian",
    "Cameroonian",
    "Canadian",
    "Cape Verdean",
    "Cayman Islander",
    "Central African",
    "Chadian",
    "Chilean",
    "Chinese",
    "Colombian",
    "Comoran",
    "Congolese (Congo)",
    "Congolese (DRC)",
    "Cook Islander",
    "Costa Rican",
    "Croatian",
    "Cuban",
    "Cymraes",
    "Cymro",
    "Cypriot",
    "Czech",
    "Danish",
    "Dagestani",
    "Djiboutian",
    "Dominican",
    "Citizen of the Dominican Republic",
    "Dutch",
    "East Timorese",
    "Ecuadorean",
    "Egyptian",
    "Emirati",
    "English",
    "Equatorial Guinean",
    "Eritrean",
    "Estonian",
    "Ethiopian",
    "Faroese",
    "Fijian",
    "Filipino",
    "Finnish",
    "French",
    "French Guianes",
    "Gabonese",
    "Gambian",
    "Georgian",
    "German",
    "Ghanaian",
    "Gibraltarian",
    "Greek",
    "Greenlandic",
    "Grenadian",
    "Guamanian",
    "Guatemalan",
    "Citizen of Guinea-Bissau",
    "Guinean",
    "Guyanese",
    "Haitian",
    "Honduran",
    "Hong Konger",
    "Hungarian",
    "Icelandic",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Israeli",
    "Italian",
    "Ivorian",
    "Jamaican",
    "Japanese",
    "Jordanian",
    "Kazakh",
    "Kenyan",
    "Kittitian",
    "Citizen of Kiribati",
    "Kosovan",
    "Kuwaiti",
    "Kyrgyz",
    "Lao",
    "Latvian",
    "Lebanese",
    "Liberian",
    "Libyan",
    "Liechtenstein citizen",
    "Lithuanian",
    "Luxembourger",
    "Mariana Islander",
    "Macanese",
    "Macedonian",
    "Malagasy",
    "Malawian",
    "Malaysian",
    "Maldivian",
    "Malian",
    "Maltese",
    "Marshallese",
    "Martiniquais",
    "Mauritanian",
    "Mauritian",
    "Mexican",
    "Micronesian",
    "Moldovan",
    "Monegasque",
    "Mongolian",
    "Montenegrin",
    "Montserratian",
    "Moroccan",
    "Mosotho",
    "Mozambican",
    "Namibian",
    "Nauruan",
    "Nepalese",
    "New Caledonian",
    "New Zealander",
    "Nicaraguan",
    "Nigerian",
    "Nigerien",
    "Niuean",
    "North Korean",
    "Northern Irish",
    "Norwegian",
    "Omani",
    "Okinawan",
    "Pakistani",
    "Palauan",
    "Palestinian",
    "Panamanian",
    "Papua New Guinean",
    "Paraguayan",
    "Peruvian",
    "Pitcairn Islander",
    "Polish",
    "Portuguese",
    "Prydeinig",
    "Puerto Rican",
    "Qatari",
    "Romanian",
    "Russian",
    "Rwandan",
    "Salvadorean",
    "Sammarinese",
    "Samoan",
    "Sao Tomean",
    "Saudi Arabian",
    "Scottish",
    "Senegalese",
    "Serbian",
    "Citizen of Seychelles",
    "Sierra Leonean",
    "Singaporean",
    "Slovak",
    "Slovenian",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Korean",
    "South Sudanese",
    "Spanish",
    "Sri Lankan",
    "St Helenian",
    "St Lucian",
    "Stateless",
    "Sudanese",
    "Surinamese",
    "Swazi",
    "Swedish",
    "Swiss",
    "Syrian",
    "Taiwanese",
    "Tajik",
    "Tanzanian",
    "Tasmanian",
    "Thai",
    "Togolese",
    "Tongan",
    "Trinidadian",
    "Tristanian",
    "Tunisian",
    "Turkish",
    "Turkmen",
    "Turks and Caicos Islander",
    "Tuvaluan",
    "Ugandan",
    "Ukrainian",
    "Uruguayan",
    "Uzbek",
    "Vatican citizen",
    "Citizen of Vanuatu",
    "Venezuelan",
    "Vietnamese",
    "Vincentian",
    "Wallisian",
    "Welsh",
    "Yemeni",
    "Yugoslav",
    "Zambian",
    "Zimbabwean",
];
export const nationalitiesAr = [
    "أفغاني",
    "ألباني",
    "جزائري",
    "أمريكي",
    "أندوري",
    "أنغولي",
    "أنغويلي",
    "مواطن من أنتيغوا",
    "مواطن من أنتيغوا وبربودا",
    "أرجنتيني",
    "أرميني",
    "أسترالي",
    "نمساوي",
    "أذربيجاني",
    "باهامي",
    "بحريني",
    "بنغالي",
    "باربادوسي",
    "بيلاروسي",
    "بلجيكي",
    "بليزي",
    "بيني",
    "برمودي",
    "بوتاني",
    "بوليفي",
    "مواطن من البوسنة والهرسك",
    "بوتسواني",
    "برازيلي",
    "بريطاني",
    "من جزر العذراء البريطانية",
    "بروناي",
    "بلغاري",
    "بوركيني",
    "بورمي",
    "بوروندي",
    "كمبودي",
    "كاميروني",
    "كندي",
    "من الرأس الأخضر",
    "من جزر كايمان",
    "إفريقي وسط",
    "تشادي",
    "شيلي",
    "صيني",
    "كولومبي",
    "قمري",
    "كونغولي (الكونغو)",
    "كونغولي (جمهورية الكونغو الديمقراطية)",
    "من جزر كوك",
    "كوستاريكي",
    "كرواتي",
    "كوبي",
    "ويلزية",
    "ويلزي",
    "قبرصي",
    "تشيكي",
    "دنماركي",
    "داغستاني",
    "جيبوتي",
    "دومينيكي",
    "مواطن من جمهورية الدومينيكان",
    "هولندي",
    "تيموري شرقي",
    "إكوادوري",
    "مصري",
    "إماراتي",
    "إنجليزي",
    "غيني استوائي",
    "إريتري",
    "استوني",
    "أثيوبي",
    "فاروي",
    "فيجي",
    "فلبيني",
    "فنلندي",
    "فرنسي",
    "غوياني فرنسي",
    "غابوني",
    "غامبي",
    "جورجي",
    "ألماني",
    "غاني",
    "جبل طارق",
    "يوناني",
    "غرينلاندي",
    "غرينادي",
    "غوامي",
    "غواتيمالي",
    "مواطن من غينيا بيساو",
    "غيني",
    "غوياني",
    "هايتي",
    "هندوراسي",
    "من هونغ كونغ",
    "هنغاري",
    "أيسلندي",
    "هندي",
    "إندونيسي",
    "إيراني",
    "عراقي",
    "أيرلندي",
    "إسرائيلي",
    "إيطالي",
    "إيفواري",
    "جامايكي",
    "ياباني",
    "أردني",
    "كازاخي",
    "كيني",
    "من سانت كيتس ونيفيس",
    "مواطن من كيريباتي",
    "كوسوفي",
    "كويتي",
    "قرغيزي",
    "لاوي",
    "لاتفي",
    "لبناني",
    "ليبيري",
    "ليبي",
    "مواطن من ليختنشتاين",
    "ليتواني",
    "لوكسمبورغي",
    "مواطن من جزر ماريانا",
    "ماكاوي",
    "مقدوني",
    "مدغشقري",
    "مالاوي",
    "ماليزي",
    "مالديفي",
    "مالي",
    "مالطي",
    "مارشالي",
    "مارتينيكي",
    "موريتاني",
    "موريشي",
    "مكسيكي",
    "ميكرونيزي",
    "مولدوفي",
    "موناكي",
    "منغولي",
    "مونتينيغري",
    "مونتسيراتي",
    "مغربي",
    "موسوتو",
    "موزمبيقي",
    "ناميبي",
    "ناوروي",
    "نيبالي",
    "كاليدوني",
    "نيوزيلندي",
    "نيكاراغوي",
    "نيجيري",
    "نيجري",
    "نيوي",
    "كوري شمالي",
    "أيرلندي شمالي",
    "نرويجي",
    "عماني",
    "مواطن من أوكيناوا",
    "باكستاني",
    "بالاوي",
    "فلسطيني",
    "بنمي",
    "بابوا غيني",
    "باراغوي",
    "برو",
    "من جزر بيتكيرن",
    "بولندي",
    "برتغالي",
    "بريدي",
    "بورتوريكي",
    "قطري",
    "روماني",
    "روسي",
    "رواندي",
    "سلفادوري",
    "سان ماريني",
    "سامي",
    "ساو تومه وبرينسيبي",
    "سعودي",
    "اسكتلندي",
    "سنغالي",
    "صربي",
    "مواطن من سيشل",
    "سيراليوني",
    "سنغافوري",
    "سلوفاكي",
    "سلوفيني",
    "من جزر سولومون",
    "صومالي",
    "جنوب أفريقي",
    "كوري جنوبي",
    "جنوب سوداني",
    "إسباني",
    "سريلانكي",
    "من سانت هيليني",
    "من سانت لوسيا",
    "بلا جنسية",
    "سوداني",
    "سورينامي",
    "سوازي",
    "سويدي",
    "سويسري",
    "سوري",
    "تايواني",
    "طاجيكي",
    "تنزاني",
    "واطن من تسمانيا",
    "تايلاندي",
    "توجولي",
    "تونغاني",
    "ترينيدادي",
    "ترستادي",
    "تونسي",
    "تركي",
    "تركماني",
    "من جزر تركس وكايكوس",
    "توفالو",
    "أوغندي",
    "أوكراني",
    "أوروغوياني",
    "أوزبكي",
    "مواطن من الفاتيكان",
    "مواطن من فانواتو",
    "فنزويلي",
    "فيتنامي",
    "سانت فنسنتي",
    "من واليس وفوتونا",
    "ويلزي",
    "يمني",
    "يوغسلافي",
    "زامبي",
    "زيمبابوي",
];
export const nationalitiesWithMoHRECode = [
    [312, "Indonesian"],
    [313, "Cypriot"],
    [314, "Chinese"],
    [315, "Taiwanese"],
    [316, "Nepalese"],
    [117, "Hong Konger"],
    [318, "Burmese"],
    [320, "Lao"],
    [321, "Cambodian"],
    [322, "Mongolian"],
    [323, "Vietnamese"],
    [325, "Bhutanese"],
    [326, "Azerbaijani"],
    [327, "Tajik"],
    [328, "Kazakh"],
    [329, "Turkmen"],
    [330, "Uzbek"],
    [331, "Georgian"],
    [332, "Kyrgyz"],
    [333, "Armenian"],
    [401, "Tanzanian"],
    [402, "Kenyan"],
    [403, "Ethiopian"],
    [404, "South African"],
    [405, "Senegalese"],
    [406, "Ugandan"],
    [407, "Ghanaian"],
    [408, "Malagasy"],
    [409, "Citizen of Seychelles"],
    [410, "Ivorian"],
    [411, "Mauritian"],
    [412, "Guinean"],
    [413, "Zimbabwean"],
    [414, "Gambian"],
    [116, "Liberian"],
    [417, "Comoran"],
    [118, "Cameroonian"],
    [419, "Togolese"],
    [420, "Sierra Leonean"],
    [421, "Chadian"],
    [422, "Nigerien"],
    [424, "Mozambican"],
    [425, "Zambian"],
    [426, "Congolese (DRC)"],
    [427, "Malian"],
    [428, "Gabonese"],
    [429, "Beninese"],
    [431, "Burundian"],
    [432, "Greenlandic"],
    [433, "Central African"],
    [434, "Congolese (Congo)"],
    [435, "Burkinan"],
    [436, "Malawian"],
    [437, "Rwandan"],
    [439, "Mosotho"],
    [440, "Swazi"],
    [441, "Eritrean"],
    [501, "British"],
    [502, "French"],
    [504, "German"],
    [506, "Dutch"],
    [507, "Belgian"],
    [508, "Irish"],
    [509, "Swedish"],
    [510, "Norwegian"],
    [511, "Danish"],
    [513, "Austrian"],
    [514, "Swiss"],
    [515, "Luxembourger"],
    [516, "Portuguese"],
    [517, "Spanish"],
    [518, "Greek"],
    [519, "Turkish"],
    [521, "Yugoslav"],
    [522, "Czech"],
    [523, "Polish"],
    [524, "Romanian"],
    [525, "Bulgarian"],
    [526, "Hungarian"],
    [529, "Liechtenstein Citizen"],
    [530, "Albanian"],
    [531, "Croatian"],
    [532, "Slovenian"],
    [533, "Citizen of Bosnia and Herzegovina"],
    [534, "Russian"],
    [536, "Ukrainian"],
    [537, "Lithuanian"],
    [538, "Estonian"],
    [539, "Latvian"],
    [540, "Moldovan"],
    [541, "Slovak"],
    [542, "Macedonian"],
    [543, "Serbian"],
    [601, "American"],
    [602, "Canadian"],
    [603, "Honduran"],
    [604, "Brazilian"],
    [605, "Mexican"],
    [606, "Argentine"],
    [607, "Colombian"],
    [608, "Salvadorean"],
    [609, "Venezuelan"],
    [610, "Jamaican"],
    [611, "Trinidadian"],
    [612, "Bolivian"],
    [613, "Peruvian"],
    [614, "Ecuadorean"],
    [615, "Bahamian"],
    [616, "Guyanese"],
    [617, "Chilean"],
    [619, "Nicaraguan"],
    [620, "Panamanian"],
    [621, "Barbadian"],
    [622, "Costa Rican"],
    [625, "Dominican"],
    [925, "Haitian"],
    [626, "Grenadian"],
    [628, "Martiniquais"],
    [629, "Paraguayan"],
    [630, "French Guianes"],
    [631, "Surinamese"],
    [632, "Bermudian"],
    [633, "Belizean"],
    [634, "Cuban"],
    [702, "New Zealander"],
    [703, "Fijian"],
    [704, "New Caledonian"],
    [705, "Papua New Guinean"],
    [706, "Tongan"],
    [483, "Greek"],
    [301, "Bangladeshi"],
    [324, "Bruneian"],
    [623, "Puerto Rican"],
    [373, "Namibian"],
    [491, "St Lucian"],
    [490, "Belarusian"],
    [272, "Kyrgyz"],
    [823, "Mariana Islander"],
    [820, "Solomon Islander"],
    [815, "Timorese"],
    [811, "Macanese"],
    [808, "Citizen of Guinea-Bissau"],
    [445, "Andorran"],
    [489, "Kyrgyz"],
    [723, "Okinawan"],
    [727, "Marshallese"],
    [663, "Citizen of Antigua and Barbuda"],
    [319, "Maldivian"],
    [824, "Martiniquais"],
    [821, "Sao Tomean"],
    [810, "Antiguan"],
    [806, "Cape Verdean"],
    [737, "Nauruan"],
    [618, "Uruguayan"],
    [827, "Monegasque"],
    [805, "Vatican Citizen"],
    [809, "Dagestani"],
    [825, "Cayman Islander"],
    [819, "Kittitian"],
    [814, "Tasmanian"],
    [817, "Kittitian"],
    [822, "Sammarinese"],
    [812, "Samoan"],
    [807, "Citizen of Kiribati"],
    [733, "Citizen of Vanuatu"],
    [21, "Emirati"],
    [22, "Bahraini"],
    [23, "Omani"],
    [24, "Qatari"],
    [25, "Saudi Arabian"],
    [26, "Kuwaiti"],
    [1, "Egyptian"],
    [2, "Lebanese"],
    [3, "Jordanian"],
    [4, "Syrian"],
    [5, "Palestinian"],
    [17, "Yemeni"],
    [8, "Somali"],
    [9, "Sudanese"],
    [10, "Iraqi"],
    [11, "Libyan"],
    [13, "Algerian"],
    [14, "Moroccan"],
    [15, "Djiboutian"],
    [16, "Mauritanian"],
    [100, "Indian"],
    [200, "Pakistani"],
    [302, "Iranian"],
    [304, "Filipino"],
    [305, "North Korean"],
    [306, "South Korean"],
    [307, "Japanese"],
    [308, "Thai"],
    [309, "Singaporean"],
    [310, "Malaysian"],
    [804, "Kosovan"],
    [488, "Montenegrin"],
    [138, "South Sudanese"],
    [277, "Israeli"],
    [642, "Dominican"],
    [12, "Tunisian"],
    [140, "Somali"],
    [303, "Sri Lankan"],
    [311, "Afghan"],
    [415, "Nigerian"],
    [423, "Angolan"],
    [430, "Botswanan"],
    [438, "Beninese"],
    [505, "Italian"],
    [512, "Finnish"],
    [520, "Maltese"],
    [527, "Icelandic"],
    [627, "Guatemalan"],
    [665, "Vincentian"],
    [701, "Australian"],
    [803, "Czech"],
    [813, "Tongan"],
    [816, "French"],
    [818, "British"],
    [826, "Gambian"],
    [926, "Tuvaluan"],
    [927, "Equatorial Guinean"],
];
export const countriesWithFlag = [
    { code: "AF", flag: "🇦🇫" },
    { code: "AL", flag: "🇦🇱" },
    { code: "DZ", flag: "🇩🇿" },
    { code: "AD", flag: "🇦🇩" },
    { code: "AO", flag: "🇦🇴" },
    { code: "AG", flag: "🇦🇬" },
    { code: "AI", flag: "🇦🇮" },
    { code: "AR", flag: "🇦🇷" },
    { code: "AM", flag: "🇦🇲" },
    { code: "AU", flag: "🇦🇺" },
    { code: "AT", flag: "🇦🇹" },
    { code: "AZ", flag: "🇦🇿" },
    { code: "BS", flag: "🇧🇸" },
    { code: "BH", flag: "🇧🇭" },
    { code: "BD", flag: "🇧🇩" },
    { code: "BB", flag: "🇧🇧" },
    { code: "BY", flag: "🇧🇾" },
    { code: "BE", flag: "🇧🇪" },
    { code: "BZ", flag: "🇧🇿" },
    { code: "BJ", flag: "🇧🇯" },
    { code: "BM", flag: "🇧🇲" },
    { code: "BT", flag: "🇧🇹" },
    { code: "BO", flag: "🇧🇴" },
    { code: "BA", flag: "🇧🇦" },
    { code: "BW", flag: "🇧🇼" },
    { code: "BR", flag: "🇧🇷" },
    { code: "BN", flag: "🇧🇳" },
    { code: "BG", flag: "🇧🇬" },
    { code: "BF", flag: "🇧🇫" },
    { code: "BI", flag: "🇧🇮" },
    { code: "CV", flag: "🇨🇻" },
    { code: "KH", flag: "🇰🇭" },
    { code: "CM", flag: "🇨🇲" },
    { code: "CA", flag: "🇨🇦" },
    { code: "KY", flag: "🇰🇾" },
    { code: "CF", flag: "🇨🇫" },
    { code: "TD", flag: "🇹🇩" },
    { code: "CL", flag: "🇨🇱" },
    { code: "CN", flag: "🇨🇳" },
    { code: "CO", flag: "🇨🇴" },
    { code: "KM", flag: "🇰🇲" },
    { code: "CG", flag: "🇨🇬" },
    { code: "CD", flag: "🇨🇩" },
    { code: "CK", flag: "🇨🇰" },
    { code: "CR", flag: "🇨🇷" },
    { code: "CI", flag: "🇨🇮" },
    { code: "HR", flag: "🇭🇷" },
    { code: "CU", flag: "🇨🇺" },
    { code: "CY", flag: "🇨🇾" },
    { code: "CZ", flag: "🇨🇿" },
    { code: "DK", flag: "🇩🇰" },
    { code: "DJ", flag: "🇩🇯" },
    { code: "DM", flag: "🇩🇲" },
    { code: "DO", flag: "🇩🇴" },
    { code: "EC", flag: "🇪🇨" },
    { code: "EG", flag: "🇪🇬" },
    { code: "SV", flag: "🇸🇻" },
    { code: "GQ", flag: "🇬🇶" },
    { code: "ER", flag: "🇪🇷" },
    { code: "EE", flag: "🇪🇪" },
    { code: "SZ", flag: "🇸🇿" },
    { code: "ET", flag: "🇪🇹" },
    { code: "FO", flag: "🇫🇴" },
    { code: "FJ", flag: "🇫🇯" },
    { code: "FI", flag: "🇫🇮" },
    { code: "FR", flag: "🇫🇷" },
    { code: "GA", flag: "🇬🇦" },
    { code: "GM", flag: "🇬🇲" },
    { code: "GE", flag: "🇬🇪" },
    { code: "DE", flag: "🇩🇪" },
    { code: "GH", flag: "🇬🇭" },
    { code: "GI", flag: "🇬🇮" },
    { code: "GR", flag: "🇬🇷" },
    { code: "GL", flag: "🇬🇱" },
    { code: "GD", flag: "🇬🇩" },
    { code: "GU", flag: "🇬🇺" },
    { code: "GT", flag: "🇬🇹" },
    { code: "GN", flag: "🇬🇳" },
    { code: "GW", flag: "🇬🇼" },
    { code: "GY", flag: "🇬🇾" },
    { code: "HT", flag: "🇭🇹" },
    { code: "HN", flag: "🇭🇳" },
    { code: "HK", flag: "🇭🇰" },
    { code: "HU", flag: "🇭🇺" },
    { code: "IS", flag: "🇮🇸" },
    { code: "IN", flag: "🇮🇳" },
    { code: "ID", flag: "🇮🇩" },
    { code: "IR", flag: "🇮🇷" },
    { code: "IQ", flag: "🇮🇶" },
    { code: "IE", flag: "🇮🇪" },
    { code: "IL", flag: "🇮🇱" },
    { code: "IT", flag: "🇮🇹" },
    { code: "JM", flag: "🇯🇲" },
    { code: "JP", flag: "🇯🇵" },
    { code: "JO", flag: "🇯🇴" },
    { code: "KZ", flag: "🇰🇿" },
    { code: "KE", flag: "🇰🇪" },
    { code: "KI", flag: "🇰🇮" },
    { code: "KP", flag: "🇰🇵" },
    { code: "KR", flag: "🇰🇷" },
    { code: "XK", flag: "🇽🇰" },
    { code: "KW", flag: "🇰🇼" },
    { code: "KG", flag: "🇰🇬" },
    { code: "LA", flag: "🇱🇦" },
    { code: "LV", flag: "🇱🇻" },
    { code: "LB", flag: "🇱🇧" },
    { code: "LS", flag: "🇱🇸" },
    { code: "LR", flag: "🇱🇷" },
    { code: "LY", flag: "🇱🇾" },
    { code: "LI", flag: "🇱🇮" },
    { code: "LT", flag: "🇱🇹" },
    { code: "LU", flag: "🇱🇺" },
    { code: "MO", flag: "🇲🇴" },
    { code: "MG", flag: "🇲🇬" },
    { code: "MW", flag: "🇲🇼" },
    { code: "MY", flag: "🇲🇾" },
    { code: "MV", flag: "🇲🇻" },
    { code: "ML", flag: "🇲🇱" },
    { code: "MT", flag: "🇲🇹" },
    { code: "MH", flag: "🇲🇭" },
    { code: "MQ", flag: "🇲🇶" },
    { code: "MR", flag: "🇲🇷" },
    { code: "MU", flag: "🇲🇺" },
    { code: "MX", flag: "🇲🇽" },
    { code: "FM", flag: "🇫🇲" },
    { code: "MD", flag: "🇲🇩" },
    { code: "MC", flag: "🇲🇨" },
    { code: "MN", flag: "🇲🇳" },
    { code: "ME", flag: "🇲🇪" },
    { code: "MS", flag: "🇲🇸" },
    { code: "MA", flag: "🇲🇦" },
    { code: "MZ", flag: "🇲🇿" },
    { code: "MM", flag: "🇲🇲" },
    { code: "NA", flag: "🇳🇦" },
    { code: "NR", flag: "🇳🇷" },
    { code: "NP", flag: "🇳🇵" },
    { code: "NL", flag: "🇳🇱" },
    { code: "NZ", flag: "🇳🇿" },
    { code: "NI", flag: "🇳🇮" },
    { code: "NE", flag: "🇳🇪" },
    { code: "NG", flag: "🇳🇬" },
    { code: "NU", flag: "🇳🇺" },
    { code: "MK", flag: "🇲🇰" },
    { code: "NO", flag: "🇳🇴" },
    { code: "OM", flag: "🇴🇲" },
    { code: "PK", flag: "🇵🇰" },
    { code: "PW", flag: "🇵🇼" },
    { code: "PS", flag: "🇵🇸" },
    { code: "PA", flag: "🇵🇦" },
    { code: "PG", flag: "🇵🇬" },
    { code: "PY", flag: "🇵🇾" },
    { code: "PE", flag: "🇵🇪" },
    { code: "PH", flag: "🇵🇭" },
    { code: "PN", flag: "🇵🇳" },
    { code: "PL", flag: "🇵🇱" },
    { code: "PT", flag: "🇵🇹" },
    { code: "PR", flag: "🇵🇷" },
    { code: "QA", flag: "🇶🇦" },
    { code: "RO", flag: "🇷🇴" },
    { code: "RU", flag: "🇷🇺" },
    { code: "RW", flag: "🇷🇼" },
    { code: "SH", flag: "🇸🇭" },
    { code: "KN", flag: "🇰🇳" },
    { code: "LC", flag: "🇱🇨" },
    { code: "VC", flag: "🇻🇨" },
    { code: "WS", flag: "🇼🇸" },
    { code: "SM", flag: "🇸🇲" },
    { code: "ST", flag: "🇸🇹" },
    { code: "SA", flag: "🇸🇦" },
    { code: "SN", flag: "🇸🇳" },
    { code: "RS", flag: "🇷🇸" },
    { code: "SC", flag: "🇸🇨" },
    { code: "SL", flag: "🇸🇱" },
    { code: "SG", flag: "🇸🇬" },
    { code: "SK", flag: "🇸🇰" },
    { code: "SI", flag: "🇸🇮" },
    { code: "SB", flag: "🇸🇧" },
    { code: "SO", flag: "🇸🇴" },
    { code: "ZA", flag: "🇿🇦" },
    { code: "SS", flag: "🇸🇸" },
    { code: "ES", flag: "🇪🇸" },
    { code: "LK", flag: "🇱🇰" },
    { code: "SD", flag: "🇸🇩" },
    { code: "SR", flag: "🇸🇷" },
    { code: "SE", flag: "🇸🇪" },
    { code: "CH", flag: "🇨🇭" },
    { code: "SY", flag: "🇸🇾" },
    { code: "TW", flag: "🇹🇼" },
    { code: "TJ", flag: "🇹🇯" },
    { code: "TZ", flag: "🇹🇿" },
    { code: "TH", flag: "🇹🇭" },
    { code: "TL", flag: "🇹🇱" },
    { code: "TG", flag: "🇹🇬" },
    { code: "TO", flag: "🇹🇴" },
    { code: "TT", flag: "🇹🇹" },
    { code: "TN", flag: "🇹🇳" },
    { code: "TR", flag: "🇹🇷" },
    { code: "TM", flag: "🇹🇲" },
    { code: "TC", flag: "🇹🇨" },
    { code: "TV", flag: "🇹🇻" },
    { code: "UG", flag: "🇺🇬" },
    { code: "UA", flag: "🇺🇦" },
    { code: "AE", flag: "🇦🇪" },
    { code: "GB", flag: "🇬🇧" },
    { code: "US", flag: "🇺🇸" },
    { code: "UY", flag: "🇺🇾" },
    { code: "UZ", flag: "🇺🇿" },
    { code: "VU", flag: "🇻🇺" },
    { code: "VE", flag: "🇻🇪" },
    { code: "VG", flag: "🇻🇬" },
    { code: "VN", flag: "🇻🇳" },
    { code: "WF", flag: "🇼🇫" },
    { code: "YE", flag: "🇾🇪" },
    { code: "ZM", flag: "🇿🇲" },
    { code: "ZW", flag: "🇿🇼" },
];
export const countriesWithCode = {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AD: "Andorra",
    AO: "Angola",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    BN: "Brunei",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    CV: "Cabo Verde",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo (Congo-Brazzaville)",
    CR: "Costa Rica",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czechia (Czech Republic)",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    SZ: "Eswatini (fmr. Swaziland)",
    ET: "Ethiopia",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GR: "Greece",
    GD: "Grenada",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HN: "Honduras",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran",
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "Korea (North)",
    KR: "Korea (South)",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Laos",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MR: "Mauritania",
    MU: "Mauritius",
    MX: "Mexico",
    FM: "Micronesia",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar (formerly Burma)",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    MK: "North Macedonia",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestine",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PL: "Poland",
    PT: "Portugal",
    QA: "Qatar",
    RO: "Romania",
    RU: "Russia",
    RW: "Rwanda",
    KN: "Saint Kitts and Nevis",
    LC: "Saint Lucia",
    VC: "Saint Vincent and the Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome and Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syria",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Vietnam",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
};
export const countriesWithCodeAr = {
    AF: "أفغانستان",
    AL: "ألبانيا",
    DZ: "الجزائر",
    AD: "أندورا",
    AO: "أنغولا",
    AG: "أنتيغوا وبربودا",
    AR: "الأرجنتين",
    AM: "أرمينيا",
    AU: "أستراليا",
    AT: "النمسا",
    AZ: "أذربيجان",
    BS: "الباهاما",
    BH: "البحرين",
    BD: "بنغلاديش",
    BB: "باربادوس",
    BY: "بيلاروسيا",
    BE: "بلجيكا",
    BZ: "بليز",
    BJ: "بنين",
    BT: "بوتان",
    BO: "بوليفيا",
    BA: "البوسنة والهرسك",
    BW: "بوتسوانا",
    BR: "البرازيل",
    BN: "بروناي",
    BG: "بلغاريا",
    BF: "بوركينا فاسو",
    BI: "بوروندي",
    CV: "الرأس الأخضر",
    KH: "كمبوديا",
    CM: "الكاميرون",
    CA: "كندا",
    CF: "جمهورية أفريقيا الوسطى",
    TD: "تشاد",
    CL: "تشيلي",
    CN: "الصين",
    CO: "كولومبيا",
    KM: "جزر القمر",
    CG: "الكونغو (الكونغو-برازافيل)",
    CR: "كوستاريكا",
    HR: "كرواتيا",
    CU: "كوبا",
    CY: "قبرص",
    CZ: "التشيك",
    DK: "الدنمارك",
    DJ: "جيبوتي",
    DM: "دومينيكا",
    DO: "جمهورية الدومينيكان",
    EC: "الإكوادور",
    EG: "مصر",
    SV: "السلفادور",
    GQ: "غينيا الاستوائية",
    ER: "إريتريا",
    EE: "إستونيا",
    SZ: "إسواتيني (سوازيلاند سابقًا)",
    ET: "إثيوبيا",
    FJ: "فيجي",
    FI: "فنلندا",
    FR: "فرنسا",
    GA: "الغابون",
    GM: "غامبيا",
    GE: "جورجيا",
    DE: "ألمانيا",
    GH: "غانا",
    GR: "اليونان",
    GD: "غرينادا",
    GT: "غواتيمالا",
    GN: "غينيا",
    GW: "غينيا بيساو",
    GY: "غيانا",
    HT: "هايتي",
    HN: "هندوراس",
    HU: "المجر",
    IS: "آيسلندا",
    IN: "الهند",
    ID: "إندونيسيا",
    IR: "إيران",
    IQ: "العراق",
    IE: "أيرلندا",
    IL: "إسرائيل",
    IT: "إيطاليا",
    JM: "جامايكا",
    JP: "اليابان",
    JO: "الأردن",
    KZ: "كازاخستان",
    KE: "كينيا",
    KI: "كيريباس",
    KP: "كوريا الشمالية",
    KR: "كوريا الجنوبية",
    KW: "الكويت",
    KG: "قرغيزستان",
    LA: "لاوس",
    LV: "لاتفيا",
    LB: "لبنان",
    LS: "ليسوتو",
    LR: "ليبيريا",
    LY: "ليبيا",
    LI: "ليختنشتاين",
    LT: "ليتوانيا",
    LU: "لوكسمبورغ",
    MG: "مدغشقر",
    MW: "مالاوي",
    MY: "ماليزيا",
    MV: "جزر المالديف",
    ML: "مالي",
    MT: "مالطا",
    MH: "جزر مارشال",
    MR: "موريتانيا",
    MU: "موريشيوس",
    MX: "المكسيك",
    FM: "ميكرونيزيا",
    MD: "مولدوفا",
    MC: "موناكو",
    MN: "منغوليا",
    ME: "الجبل الأسود",
    MA: "المغرب",
    MZ: "موزمبيق",
    MM: "ميانمار (بورما سابقًا)",
    NA: "ناميبيا",
    NR: "ناورو",
    NP: "نيبال",
    NL: "هولندا",
    NZ: "نيوزيلندا",
    NI: "نيكاراغوا",
    NE: "النيجر",
    NG: "نيجيريا",
    MK: "مقدونيا الشمالية",
    NO: "النرويج",
    OM: "عمان",
    PK: "باكستان",
    PW: "بالاو",
    PS: "فلسطين",
    PA: "بنما",
    PG: "بابوا غينيا الجديدة",
    PY: "باراغواي",
    PE: "بيرو",
    PH: "الفلبين",
    PL: "بولندا",
    PT: "البرتغال",
    QA: "قطر",
    RO: "رومانيا",
    RU: "روسيا",
    RW: "رواندا",
    KN: "سانت كيتس ونيفيس",
    LC: "سانت لوسيا",
    VC: "سانت فنسنت وجزر غرينادين",
    WS: "ساموا",
    SM: "سان مارينو",
    ST: "ساو تومي وبرينسيب",
    SA: "المملكة العربية السعودية",
    SN: "السنغال",
    RS: "صربيا",
    SC: "سيشل",
    SL: "سيراليون",
    SG: "سنغافورة",
    SK: "سلوفاكيا",
    SI: "سلوفينيا",
    SB: "جزر سليمان",
    SO: "الصومال",
    ZA: "جنوب أفريقيا",
    SS: "جنوب السودان",
    ES: "إسبانيا",
    LK: "سريلانكا",
    SD: "السودان",
    SR: "سورينام",
    SE: "السويد",
    CH: "سويسرا",
    SY: "سوريا",
    TW: "تايوان",
    TJ: "طاجيكستان",
    TZ: "تنزانيا",
    TH: "تايلاند",
    TL: "تيمور الشرقية",
    TG: "توغو",
    TO: "تونغا",
    TT: "ترينيداد وتوباغو",
    TN: "تونس",
    TR: "تركيا",
    TM: "تركمانستان",
    TV: "توفالو",
    UG: "أوغندا",
    UA: "أوكرانيا",
    AE: "الإمارات العربية المتحدة",
    GB: "المملكة المتحدة",
    US: "الولايات المتحدة",
    UY: "أوروغواي",
    UZ: "أوزبكستان",
    VU: "فانواتو",
    VE: "فنزويلا",
    VN: "فيتنام",
    YE: "اليمن",
    ZM: "زامبيا",
    ZW: "زيمبابوي",
};
//# sourceMappingURL=index.js.map